import { Button, Typography, CircularProgress } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const CustomButton = ({
  status = "idle",     // "idle" | "loading"
  onClick,
  label = "Submit",
  loadingLabel = "Submitting...",
  variant = "outlined",
  icon,
  color,
  btnColor,
  borderRadius,
  ...props
}) => {
  return (
    <div style={{ cursor: status === "loading" ? "not-allowed" : "pointer" }}>
      <Button
        variant={variant}
        disabled={status === "loading"}
        onClick={status === "loading" ? null : onClick}
        sx={{
          width: "100%",
          background: color ? color : "var(--primary)",
          color: "var(--light-bg)",
          border: "none",
          borderRadius: "8px",
          borderRadius: borderRadius ?? 'none',
          px: 2,
          py: 1,
          "&.Mui-disabled": {
            cursor: "not-allowed",          // ✅ force not-allowed cursor
            opacity: 0.7,                   // optional visual cue
            background: "var(--primary)",   // keep background same
            color: "var(--light-bg)",       // keep text same
          },
        }}
        {...props}
      >
        <Typography
          sx={{
            fontWeight: 500,
            color: "var(--white)",
            display: "flex",
            alignItems: "center",
          }}
        >
          {status === "loading" && (
            <CircularProgress
              size={15}
              sx={{ mr: 1, color: "var(--white)" }}  // ✅ force white spinner
            />
          )}
          {icon ? icon : <AddIcon color={btnColor} />}&nbsp;
          {status === "loading" ? loadingLabel : label}
        </Typography>
      </Button>
    </div>
  );
};

export default CustomButton;
